import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactMarkdown from 'react-markdown';

import Brand from 'models/brand';

import LegalPageHeader from 'components/legal/header-terms.jsx';
import PrivacyPolicyPageHeader from 'components/legal/header-privacy.jsx';

const propTypes = {
  brand: PropTypes.instanceOf(Brand).isRequired,
};

const LegalPage = ({ brand }) => (
  <div className="margin-bottom-40">
    <LegalPageHeader brand={brand} />
    <div className="row">
      <div className="container">
        <ReactMarkdown
          source={brand.termsOfService}
          className="col-sm-10 col-sm-offset-1 text-color-dark-slate text-size-xs-12 text-size-sm-14 text-weight-book"
        />
      </div>
    </div>
    <PrivacyPolicyPageHeader />
    <div className="row">
      <div className="container">
        <ReactMarkdown
          source={brand.privacyPolicy}
          className="col-sm-10 col-sm-offset-1 text-color-dark-slate text-size-xs-12 text-size-sm-14 text-weight-book"
        />
      </div>
    </div>
  </div>
);

const mapStateToProps = (state) => {
  const { brand } = state.brand;
  return { brand };
};

LegalPage.propTypes = propTypes;

export default connect(mapStateToProps)(LegalPage);
